import type { ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "../../../lib/utils.js";

interface AuthAlertProps {
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function AuthAlert({ children, actions, className }: AuthAlertProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center gap-3 rounded-[12px] border border-[#f8aba5] bg-[#fff5f5] p-[16px] text-center shadow-sm animate-in fade-in zoom-in-95",
        className
      )}
      role="alert"
    >
      <div className="flex items-center justify-center gap-2">
        <AlertCircle size={20} className="shrink-0 text-[#d92d20]" aria-hidden="true" />
        <span className="text-[14px] font-[600] leading-snug text-[#5e1515] wrap-anywhere">
          {children}
        </span>
      </div>
      
      {actions ? (
        <div className="mt-1 flex flex-wrap items-center justify-center gap-3">
          {actions}
        </div>
      ) : null}
    </div>
  );
}